var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFourthStepIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 64,
    viewBox: "0 0 65 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 25.5,
    y: 7,
    width: 34,
    height: 34,
    fill: "url(#pattern0)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.9839 23.1934C41.9839 23.1934 37.2928 26.4399 30.4678 26.5805V37.8273C30.4677 39.6482 30.8741 41.4462 31.6572 43.0902C32.4404 44.7341 33.5805 46.1825 34.9946 47.3298L41.9839 52.9998L48.9731 47.3298C50.3872 46.1825 51.5274 44.7341 52.3106 43.0902C53.0937 41.4462 53.5001 39.6482 53.5 37.8273V26.5805C46.675 26.4399 41.9839 23.1934 41.9839 23.1934Z",
    stroke: "#39546A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.0157 34.7095V30.645H39.9512V34.7095H35.8867V38.774H39.9512V42.8385H44.0157V38.774H48.0802V34.7095H44.0157Z",
    stroke: "#39546A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6934 30.645H30.4675",
    stroke: "#39546A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6934 36.0645H30.4675",
    stroke: "#39546A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0315 41.4839H23.6934",
    stroke: "#39546A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9518 31.3226C19.326 31.3226 19.6293 31.0193 19.6293 30.6452C19.6293 30.2711 19.326 29.9678 18.9518 29.9678C18.5777 29.9678 18.2744 30.2711 18.2744 30.6452C18.2744 31.0193 18.5777 31.3226 18.9518 31.3226Z",
    stroke: "#39546A",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9518 36.7416C19.326 36.7416 19.6293 36.4383 19.6293 36.0641C19.6293 35.69 19.326 35.3867 18.9518 35.3867C18.5777 35.3867 18.2744 35.69 18.2744 36.0641C18.2744 36.4383 18.5777 36.7416 18.9518 36.7416Z",
    stroke: "#39546A",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9518 42.161C19.326 42.161 19.6293 41.8577 19.6293 41.4836C19.6293 41.1094 19.326 40.8062 18.9518 40.8062C18.5777 40.8062 18.2744 41.1094 18.2744 41.4836C18.2744 41.8577 18.5777 42.161 18.9518 42.161Z",
    stroke: "#39546A",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8873 19.129V16.4193C35.8873 15.8804 35.6732 15.3634 35.292 14.9823C34.9109 14.6012 34.394 14.3871 33.855 14.3871H32.5002V11H21.6615V14.3871H20.3067C19.7677 14.3871 19.2508 14.6012 18.8697 14.9823C18.4885 15.3634 18.2744 15.8804 18.2744 16.4193V19.129H35.8873Z",
    stroke: "#39546A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0488 15.0645V15.7419H29.1133V15.0645",
    stroke: "#39546A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8871 53H12.8548C12.4955 53 12.1509 52.8573 11.8968 52.6032C11.6427 52.3491 11.5 52.0045 11.5 51.6452V17.7743C11.5 17.4149 11.6427 17.0703 11.8968 16.8163C12.1509 16.5622 12.4955 16.4194 12.8548 16.4194H14.2097",
    stroke: "#39546A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8867 16.4194H40.6286C40.988 16.4194 41.3326 16.5622 41.5867 16.8163C41.8407 17.0703 41.9835 17.4149 41.9835 17.7743V18.4517",
    stroke: "#39546A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_7353_209842",
    transform: "scale(0.0357143)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_7353_209842",
    width: 28,
    height: 28,
    xlinkHref: "data:image/png;base64,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"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFourthStepIcon);
export default __webpack_public_path__ + "static/media/FourthStepIcon.e1dc4c40717fbe0b37ca44b2c6d60c80.svg";
export { ForwardRef as ReactComponent };